import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = {
    services: [
      { name: 'Napelem telepítés', href: '/napelem' },
      { name: 'Villanyszerelés', href: '/villanyszereles' },
      { name: 'Klíma telepítés', href: '/klima' },
      { name: 'Berendezés gyártás', href: '/berendezesgyartas' },
      { name: 'Villamos tervezés', href: '/villamostervezes' },
      { name: 'Rendezvények', href: '/rendezvenyek' }
    ],
    company: [
      { name: 'Rólunk', href: '/#about' },
      { name: 'Referenciák', href: '/#testimonials' },
      { name: 'Kapcsolat', href: '/#contact' },
      { name: 'ÁSZF', href: '/aszf' },
      { name: 'Adatvédelem', href: '/adatvedelem' }
    ],
    contact: [
      { text: '📍 SZOLNOK és 100km-es körzete' },
      { text: '✉️', email: 'kelectrokft@gmail.com' },
      { text: '🕒 Hétfő-Péntek: 8:00-18:00' }
    ]
  };

  return (
    <footer className="bg-gradient-to-t from-dark to-secondary/50 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-32 h-32 border border-primary/10 rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-24 h-24 border border-primary/10 rounded-full"></div>
      
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4">
                <span className="text-primary">K-Electro</span> Kft.
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Professzionális villanyszerelési szolgáltatások több mint 5 éves tapasztalattal. 
                Megbízható partnerük minden elektromos munkához.
              </p>
              <div className="text-gray-400 text-sm mt-4 space-y-1">
                <p>Cégjegyzékszám: 13-09-216399</p>
                <p>Adószám: 27489394-2-13</p>
                <p>2740 Abony, Mikes Kelemen utca 36</p>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Szolgáltatások</h4>
            <ul className="space-y-3">
              {footerSections.services.map((service, index) => (
                <li key={index}>
                  <a 
                    href={service.href}
                    className="text-gray-300 hover:text-primary transition-colors duration-300 block py-1"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Vállalat</h4>
            <ul className="space-y-3">
              {footerSections.company.map((item, index) => (
                <li key={index}>
                  <a 
                    href={item.href}
                    className="text-gray-300 hover:text-primary transition-colors duration-300 block py-1"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Elérhetőség</h4>
            <ul className="space-y-3">
              {footerSections.contact.map((contact, index) => (
                <li key={index} className="text-gray-300 py-1">
                  {contact.email ? (
                    <span>
                      {contact.text} <a href={`mailto:${contact.email}`} className="text-white hover:text-primary transition-colors">{contact.email}</a>
                    </span>
                  ) : (
                    contact.text
                  )}
                </li>
              ))}
            </ul>
            
            {/* Quick Contact */}
            <div className="mt-6 pt-6 border-t border-primary/20">
              <p className="text-primary font-semibold mb-2">Villanyszerelő mester:</p>
              <a 
                href="tel:+36703620652"
                className="text-white text-lg font-bold hover:text-primary transition-colors block mb-2"
              >
                Nagy Péter: +36703620652
              </a>
              <p className="text-primary font-semibold mb-2">Villamos felülvizsgáló:</p>
              <a 
                href="tel:+36706049889"
                className="text-white text-lg font-bold hover:text-primary transition-colors"
              >
                Tamasi Krisztán: +36706049889
              </a>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="mt-12 pt-8 border-t border-primary/20">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-xl font-bold text-white mb-4">
              Feliratkozás hírlevelünkre
            </h3>
            <p className="text-gray-300 mb-6">
              Legyen naprakész legújabb szolgáltatásainkról és különleges ajánlatainkról!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Email címe"
                className="flex-1 p-3 bg-gray-800/50 backdrop-blur-sm text-white rounded-lg border border-gray-600 focus:border-primary focus:ring-2 focus:ring-primary/50 transition-all duration-300"
              />
              <button className="bg-primary hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 hover:shadow-lg">
                Feliratkozom
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-dark/80 backdrop-blur-sm border-t border-primary/20">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} K-Electro Kft. Minden jog fenntartva.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/adatvedelem" className="text-gray-400 hover:text-primary transition-colors">
                Adatvédelmi szabályzat
              </a>
              <a href="/aszf" className="text-gray-400 hover:text-primary transition-colors">
                Általános Szerződési Feltételek
              </a>
              <a href="/adatvedelem" className="text-gray-400 hover:text-primary transition-colors">
                Cookie szabályzat
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 